/*
 * This file is part of the Lundhs Realstone 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';

/**
 * This is the ImgixImage component.
 *
 * @author Anders Stalheim Øfsdahl <anders@apt.no>
 *
 * @return {JSX}
 */
function ImgixImage({
  className,
  style,
  images,
  altText,
  description,
  sizes,
  eager,
  onClick,
  ariaHidden,
}) {
  const srcset = images.map(
    (image) => `${image.url} ${parseInt(image.width, 10)}w`
  );

  return (
    <ResponsiveImage
      className={className}
      style={style}
      srcset={srcset}
      altText={altText}
      src={images[0].url}
      sizes={sizes}
      eager={eager}
      description={description}
      onClick={onClick}
      ariaHidden={ariaHidden}
    />
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ImgixImage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  eager: PropTypes.bool,
  description: PropTypes.string,
  altText: PropTypes.string,
  sizes: PropTypes.array,
  images: PropTypes.array,
  onClick: PropTypes.func,
  ariaHidden: PropTypes.bool,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
ImgixImage.defaultProps = {
  className: null,
  style: null,
  eager: false,
  description: null,
  altText: null,
  sizes: ['100vw'],
  images: [],
  onClick: null,
  ariaHidden: false,
};

export default ImgixImage;
